/**
 * Before/after image compare slider — standalone init
 * Used by: snippets/dashcam-image-compare.liquid
 */
(function () {
  'use strict';

  function initCompare(root) {
    if (!root || root.dataset.compareInit === 'true') return;

    const media = root.querySelector('.dashcam-image-compare__media');
    const beforeLayer = root.querySelector('[data-dashcam-image-compare-before]');
    const sliderLine = root.querySelector('[data-dashcam-image-compare-line]');
    const sliderKnob = root.querySelector('[data-dashcam-image-compare-knob]');
    if (!media || !beforeLayer || !sliderLine || !sliderKnob) return;

    root.dataset.compareInit = 'true';

    let currentPosition = parseFloat(root.dataset.comparePosition || '50');
    let activePointerId = null;

    sliderKnob.setAttribute('role', 'slider');
    sliderKnob.setAttribute('tabindex', '0');

    function updateSlider(position) {
      position = Math.max(0, Math.min(100, position));
      currentPosition = position;
      beforeLayer.style.clipPath = 'inset(0 ' + (100 - position) + '% 0 0)';
      sliderLine.style.left = position + '%';
      sliderKnob.style.left = position + '%';
      sliderKnob.setAttribute('aria-valuenow', String(Math.round(position)));
      root.classList.toggle('is-at-left-end', position <= 1);
    }

    function handleMove(clientX) {
      const rect = media.getBoundingClientRect();
      if (!rect.width) return;
      updateSlider(((clientX - rect.left) / rect.width) * 100);
    }

    function stopDrag(pointerId) {
      if (activePointerId === null || activePointerId !== pointerId) return;
      activePointerId = null;
      root.classList.remove('is-dragging');
      document.removeEventListener('pointermove', onDocumentPointerMove);
      document.removeEventListener('pointerup', onDocumentPointerUp);
      document.removeEventListener('pointercancel', onDocumentPointerUp);
    }

    function onDocumentPointerMove(e) {
      if (activePointerId !== e.pointerId) return;
      handleMove(e.clientX);
      e.preventDefault();
    }

    function onDocumentPointerUp(e) {
      stopDrag(e.pointerId);
    }

    function startDrag(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      activePointerId = e.pointerId;
      root.classList.add('is-dragging');
      document.addEventListener('pointermove', onDocumentPointerMove);
      document.addEventListener('pointerup', onDocumentPointerUp);
      document.addEventListener('pointercancel', onDocumentPointerUp);
      handleMove(e.clientX);
      e.preventDefault();
    }

    media.addEventListener('pointerdown', startDrag);
    sliderKnob.addEventListener('pointerdown', startDrag);

    sliderKnob.addEventListener('keydown', function (e) {
      let newPosition = currentPosition;

      switch (e.key) {
        case 'ArrowLeft':
        case 'ArrowDown':
          newPosition -= 5;
          e.preventDefault();
          break;
        case 'ArrowRight':
        case 'ArrowUp':
          newPosition += 5;
          e.preventDefault();
          break;
        case 'Home':
          newPosition = 0;
          e.preventDefault();
          break;
        case 'End':
          newPosition = 100;
          e.preventDefault();
          break;
        default:
          return;
      }

      updateSlider(newPosition);
    });

    const revealButton = root.parentElement && root.parentElement.querySelector('[data-dashcam-compare-reveal]');
    if (revealButton && revealButton.dataset.compareRevealBound !== 'true') {
      revealButton.dataset.compareRevealBound = 'true';
      revealButton.addEventListener('click', function () {
        updateSlider(0);
        sliderKnob.focus();
      });
    }

    updateSlider(currentPosition);

    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(function () {
        updateSlider(currentPosition);
      });
      resizeObserver.observe(media);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-dashcam-image-compare]').forEach(initCompare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
  document.addEventListener('dashcam:ready', initAll);

  window.dashcamInitImageCompares = initAll;
})();
